import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import Banner from '@/components/ui/banner';
import { TriangleAlert } from 'lucide-react';
import { BANNER_TITLE, DESCRIPTION } from './delete-space-modal.constant';
import { useDeleteSpaceModal } from './use-delete-space-modal';
import {
  ModalCloseButton,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';

export type TDeleteSpaceModalType = 'DeleteSpaceModal';
export interface IDeleteSpaceModalProps {
  spaceId: string;
}
const DeleteSpaceModal = memo((props: IDeleteSpaceModalProps) => {
  const {
    // Form
    form,

    // Modal
    isOpenDeleteSpaceModal,

    // Helpers
    isDisabledForm,
    isLoadingForm,

    // Handlers
    handleClose,
    handleSubmitForm,
  } = useDeleteSpaceModal({
    spaceId: props.spaceId,
  });

  return (
    <Modal
      isOpen={isOpenDeleteSpaceModal}
      lockBodyScroll
      onClose={handleClose}
      className="p-[32px] md:w-[410px] w-[345px]"
    >
      <ModalHeader>
        <ModalTitle>Delete Space</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="delete-space-form"
          className="grid gap-[4px]"
        >
          <Banner className="my-[8px]" icon={TriangleAlert} title={BANNER_TITLE} variant="warning" />
          <div className="text-[14px] font-normal text-[#9D9D9C]">{DESCRIPTION}</div>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleClose();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="delete-space-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner isLoading={true} className="w-[18px] h-[18px]" /> : null} Delete
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
DeleteSpaceModal.displayName = 'DeleteSpaceModal';

export default DeleteSpaceModal;
